import React from 'react';
import {
    BooleanInput,
    Edit,
    FormTab,
    ReferenceField,
    TabbedForm,
    TextField,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';

import LinkToRelatedAtomics from "./LinkToRelatedAtomics";

const SweepTitle = ({ record }) => <span>Poster #{record.reference}</span>;

const styles = {
    comment: {
        maxWidth: '20em',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
};

const SweepEdit = ({ classes, ...props }) => (
    <Edit {...props} title={<SweepTitle />}>
        <TabbedForm>
            <FormTab label="Summary">
                <TextField  source="Created" />
                <TextField  source="ConfigId" />
                <TextField  source="SweepStatus" />
                <ReferenceField label="Build" source="BuildId" reference="build">
                    <TextField source="Description.build" />
                </ReferenceField>
                <ReferenceField label="Run" source="RunId" reference="run">
                    <TextField source="GroupDescription" />
                </ReferenceField>
                <LinkToRelatedAtomics />
            </FormTab>
            <FormTab label="Action">
                <BooleanInput label="Repeat test" source="Repeat" />
            </FormTab>
        </TabbedForm>
    </Edit>
);

export default withStyles(styles)(SweepEdit);